module.exports = __webpack_public_path__ + "static/img/gbz-905-385bb.829210e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gbz-905-385bb.jpg
// module id = 6Twu
// module chunks = 0